import { ParsedUrlQuery } from "node:querystring";

import Cookies from "js-cookie";
import { useRouter } from "next/router";
import { useEffect } from "react";

import LoginForm from "../../components/auth/login";
import RegisterPageForm from "../../components/auth/register";
import Layout from "../../components/layout/pageLayout.comp";
import { useTranslation } from "../../core/translation.core";

// https://docs.amplify.aws/lib/auth/social/q/platform/js/#setup-frontend
// Login
//   Email / Number
//   Password
// Register
//   Email
//   Mobile Number / SMS
// Login / Register Google
// Login / Register Facebook

function setIsCheckout(query: ParsedUrlQuery) {
  if (!query.checkingOut) return;

  Cookies.set("checkingOut", "1", {
    expires: 1,
  });
}

export default function AuthPage() {
  const { t, msg } = useTranslation();
  const { isReady, query } = useRouter();

  useEffect(() => {
    if (isReady) {
      setIsCheckout(query);
    }
  }, [isReady, query]);

  return (
    <section className="bg-guru-floral-white flex items-center ">
      <div className="w-full mx-auto">
        {/* <PageOption /> */}
        {query.page === "login" ? <LoginForm /> : null}
        {query.page === "register" ? <RegisterPageForm /> : null}
      </div>
    </section>
  );
}

// function PageOption() {
//   const { t, msg } = useTranslation();
//   const { query, push, pathname } = useRouter();
//   const inputClass = "flex-1 text-center text-privacy font-serif p-2";
//   const selectedClass = inputClass + " text-primary border-b-2 border-primary";

//   const handleClick = (page) => {
//     push({
//       pathname: pathname,
//       query: { ...query, page },
//     });
//   };

//   return (
//     <div className="flex text-lg mb-4 ">
//       <button id="btn-login" onClick={() => handleClick("login")} className={query.page === "login" ? selectedClass : inputClass}>
//         {t(msg.login.login)}
//       </button>
//       <button
//         id="register-link"
//         onClick={() => handleClick("register")}
//         className={query.page === "register" ? selectedClass : inputClass}
//       >
//         {t(msg.login.register)}
//       </button>
//     </div>
//   );
// }
